module.exports = __webpack_public_path__ + "static/media/Program17.03fee597.jpg";